import { END_POINTS } from "../constants/url";
import {
  Category,
  CustomerBody,
  Employer,
  PortfolioDetails,
  Project,
  Sub_Category,
} from "../types/General";
import { APPROVED_STATUS, CATEGORY_TYPE, ROLES } from "../utils/enums";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const userApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployers: builder.query<
      CommonResponseType,
      {
        page: number;
        limit: number;
        search: string;
        role: number | string;
        approveStatus?: number | string;
      }
    >({
      query: ({ page, limit, search, role, approveStatus }) => ({
        url: `${END_POINTS.users}/list?role=${role}${
          approveStatus ? `&approveStatus=${approveStatus}` : ""
        }&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),

    updateStatusCustomer: builder.mutation<
      CommonResponseType & { data: Employer },
      {
        id: string;
        body: {
          isBlocked: boolean;
        };
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    updateApproveStatus: builder.mutation<
      CommonResponseType & { data: Employer },
      {
        id: string;
        body: {
          approveStatus: number;
        };
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    updateApproveStatusFreelancer: builder.mutation<
      CommonResponseType & { data: any },
      {
        id: string;
        body: {
          approveStatus: number;
          rejectReason: string;
        };
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteEmployer: builder.query<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "DELETE",
      }),
    }),

    getEmployerById: builder.query<
      CommonResponseType & { data: { user: Employer; address: any } },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "GET",
      }),
    }),

    updateEmployer: builder.mutation<
      CommonResponseType & { data: Employer },
      { id: string; body: Partial<CustomerBody> }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    userExport: builder.query<
      CommonResponseType & { data: string },
      {
        page: number;
        limit: number;
        status: number;
        search: string;
        role: number;
      }
    >({
      query: ({ page, limit, status, search, role }) => ({
        url: `${END_POINTS.export}?page=${page}&limit=${limit}&approveStatus=${status}&search=${search}&role=${role}`,
        method: "GET",
      }),
    }),
    getTaskList: builder.query<
      CommonResponseType,
      { id: string; page: number; limit: number; search: string }
    >({
      query: ({ id, page, limit, search }) => ({
        url: `${END_POINTS.task}/${id}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),

    getTaskDetailById: builder.query<
      CommonResponseType & { data: { user: Employer; address: any } },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.taskDetails}/${id}`,
        method: "GET",
      }),
    }),
    getFreelancerAssigned: builder.query<
      CommonResponseType & { data: { user: Employer; address: any } },
      { id: string; page: number; limit: number; search: string }
    >({
      query: ({ id, page, limit, search }) => ({
        url: `${END_POINTS.freelancersList}/${id}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    getPortfolio: builder.query<
      CommonResponseType & { data: { user: Project } },
      { id: string; search: string; page: number; limit: number }
    >({
      query: ({ id, search, page, limit }) => ({
        url: `${END_POINTS.portfolioList}?userId=${id}&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    getPortfolioById: builder.query<
      CommonResponseType & { data: { user: any } },
      { ProjectId: string }
    >({
      query: ({ ProjectId }) => ({
        url: `${END_POINTS.portfolioList}/${ProjectId}?`,
        method: "GET",
      }),
    }),
    updatePortfolio: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: Partial<PortfolioDetails> }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.portfolioList}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getWork: builder.query<
      CommonResponseType & { data: any },
      { id: string; search: string; page: number; limit: number }
    >({
      query: ({ id, page, limit, search }) => ({
        url: `${END_POINTS.work}/${id}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    getWorkId: builder.query<
      CommonResponseType & { data: { user: any } },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.workDetails}/${id}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useLazyGetEmployersQuery,
  useUpdateStatusCustomerMutation,
  useLazyDeleteEmployerQuery,
  useLazyGetEmployerByIdQuery,
  useUpdateEmployerMutation,
  useUpdateApproveStatusMutation,
  useLazyUserExportQuery,
  useLazyGetTaskListQuery,
  useLazyGetTaskDetailByIdQuery,
  useLazyGetFreelancerAssignedQuery,
  useUpdateApproveStatusFreelancerMutation,
  useLazyGetPortfolioQuery,
  useLazyGetPortfolioByIdQuery,
  useLazyGetWorkQuery,
  useLazyGetWorkIdQuery,
  useUpdatePortfolioMutation,
} = userApi;
